import styled, { css } from 'styled-components'
import Link from 'components/Link/Link'
import Icon from 'components/Icon/Icon'

export const StyledLink = styled(Link)`
  color: CurrentColor;
`

const iconStyles = ({ hasText, right, responsive }) => {
  const margin = right ? '0 0 0 0.25em' : '0 0.25em 0 0'

  return css`
    margin: ${hasText ? margin : 0};
    vertical-align: middle;

    @media screen and (max-width: 420px) {
      margin: ${responsive && 0};
    }
  `
}

const textStyle = ({ responsive }) => css`
  @media screen and (max-width: 420px) {
    display: ${responsive && 'none'};
  }
`

export const StyledIcon = styled(Icon)`
  ${iconStyles}
`
export const Text = styled.span`
  ${textStyle};
`
